






import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'n-ErrorLabel',
})
export default class InputLabel extends Vue {}
